module.exports = __webpack_public_path__ + "static/img/027 1.ee157fd3.jpg";